export default "__VITE_ASSET__BHn_8A64__"